module.exports = __webpack_public_path__ + "media/images/personnel/Yonette_J-9a91cb6819ac04c3e44fbb17ea6a23ba.png";